import { HttpClient } from '@angular/common/http';
import { last } from 'lodash';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigService } from '@app/core/config.service';
import { SESSION_MANAGER } from '@app/app.constants';
import * as i0 from "@angular/core";
import * as i1 from "../../config.service";
import * as i2 from "@angular/common/http";
var SpecialOffersService = /** @class */ (function () {
    function SpecialOffersService(configService, httpClient) {
        this.configService = configService;
        this.httpClient = httpClient;
        this.sessionManagerURL = this.configService.getValue(SESSION_MANAGER);
    }
    /**
     * Retrieve the Marketing offer
     * @returns special offer id
     */
    SpecialOffersService.prototype.getSpecialOfferId = function () {
        return this.specialOfferId;
    };
    /**
     * Sets the Marketing offer
     * @param marketingOffer New Marketing offer
     */
    SpecialOffersService.prototype.setSpecialOfferId = function (specialOfferId) {
        this.specialOfferId = specialOfferId;
    };
    /**
     * Retrieve special offers
     * @returns Special offers
     */
    SpecialOffersService.prototype.getSpecialOffers = function () {
        var _this = this;
        if (this.specialOffers) {
            return of(this.specialOffers);
        }
        else {
            return this.httpClient.get("" + this.sessionManagerURL).pipe(tap(function (response) {
                _this.specialOffers = response;
            }));
        }
    };
    /**
     * Update special offers object
     * @param data object to save
     * @returns Special offers
     */
    SpecialOffersService.prototype.putSpecialOffers = function (data) {
        var _this = this;
        return this.httpClient.put("" + this.sessionManagerURL, data).pipe(tap(function (response) {
            _this.specialOffers = response;
        }));
    };
    /**
     * Delete special offers object
     * @returns Special offers
     */
    SpecialOffersService.prototype.deleteSpecialOffers = function () {
        delete this.specialOfferId;
        delete this.specialOffers;
        return this.httpClient.delete("" + this.sessionManagerURL);
    };
    /**
     * Return the last affiliation retrieved from the session manager
     * https://wiki-wdpro.disney.com/display/Tech/PA+VAS+-+Product+Availability+-+Retrieve+Products
     *
     * @param affiliationsPromoCode param comming from promocode
     * @returns Affiliations
     */
    SpecialOffersService.prototype.getAffiliations = function (affiliationsPromoCode) {
        var affiliations = [];
        var lastAffilliation = last(affiliationsPromoCode);
        if (lastAffilliation) {
            affiliations.push({
                affiliationType: lastAffilliation
            });
        }
        return affiliations;
    };
    SpecialOffersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SpecialOffersService_Factory() { return new SpecialOffersService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.HttpClient)); }, token: SpecialOffersService, providedIn: "root" });
    return SpecialOffersService;
}());
export { SpecialOffersService };
